import i18n from '@/plugins/i18n';
import { setLocale } from '@vee-validate/i18n';
import { defineStore } from 'pinia';

interface ConfirmationOptions {
    title?: string;
    text?: string;
    severity?: 'error' | 'info' | 'warning';
    confirmText?: string;
    cancelText?: string;
}

export const useMainStore = defineStore('main', {
    state: () => {
        return {
            busy: false,
            locale: import.meta.env.VITE_APP_I18N_LOCALE,
            error: '' as string,
            globalDialog: {
                options: {
                    title: 'You must confirm this action',
                    text: 'Are you sure? This may come with irreversible actions',
                    severity: 'error',
                    cancelText: i18n.global.t('cancel'),
                    confirmText: i18n.global.t('confirm'),
                } as ConfirmationOptions,
                open: false,
                cooldown: 0,
                followUpAction: () => {
                    return;
                },
                cancelAction: () => {
                    return;
                },
            },
        };
    },
    actions: {
        setLoading(loading: boolean) {
            this.busy = loading;
        },
        setLocale(locale: string) {
            this.locale = locale;
            i18n.global.locale.value = this.locale;
            setLocale(this.locale);
        },
        cleanAll() {
            this.busy = false;
            this.error = '';
        },
        getData(request) {
            const formData = new FormData();
            Object.entries(request).forEach((e) => {
                const [key, val] = e;
                if (Array.isArray(val)) {
                    val.forEach((v, i) => {
                        if (v instanceof Object) {
                            Object.entries(v).forEach((el) => {
                                const [key1, val1] = el;
                                formData.append(`${key}[${i}].${key1}`, val1 as string | Blob);
                            });
                        } else formData.append(`${key}[${i}]`, v);
                    });
                } else {
                    formData.append(key, val as string | Blob);
                }
            });
            return formData;
        },

        confirmAction(followUpAction: () => void, opts?: ConfirmationOptions): void {
            this.$patch({
                globalDialog: {
                    open: true,
                    options: opts,
                    followUpAction: followUpAction,
                    cooldown: undefined,
                },
            });
        },
        confirmActionWithCooldown(
            followUpAction: () => void,
            cooldown: number,
            opts?: ConfirmationOptions
        ): void {
            this.$patch({
                globalDialog: {
                    open: true,
                    options: opts,
                    followUpAction: followUpAction,
                    cooldown: cooldown,
                },
            });
            const interval = setInterval(() => {
                if (this.globalDialog.cooldown === 0) {
                    clearInterval(interval);
                    this.$patch({
                        globalDialog: {
                            cooldown: undefined,
                        },
                    });
                } else {
                    this.$patch({
                        globalDialog: {
                            cooldown: this.globalDialog.cooldown - 1,
                        },
                    });
                    console.log(this.globalDialog.cooldown);
                }
            }, 1000);
        },
        confirmActionWithCancel(
            followUpAction: () => void,
            opts?: ConfirmationOptions,
            cancelAction?: () => void
        ): void {
            this.$patch({
                globalDialog: {
                    open: true,
                    options: opts,
                    followUpAction: followUpAction,
                    cancelAction: cancelAction,
                    cooldown: undefined,
                },
            });
        },
    },
    getters: {
        getLocale: (state) => state.locale,
    },
});
